import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-vruchtgebruikt',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-vruchtgebruik.component.html',
  styleUrl: './tekst-vruchtgebruik.component.scss',
})
export class TekstVruchtgebruikComponent {}
